export function getToolCallFormData(
  toolCallId: string
): Record<string, unknown> | undefined {
  let formData: Record<string, unknown> | undefined;

  // Get the form element inside the artifact panel
  const form = document.querySelector(
    `#artifact-panel-${toolCallId} .record-form, [data-form-id="${toolCallId}"]`
  ) as HTMLFormElement;
  if (form) {
    const fd = new FormData(form);
    formData = {};

    // preserve duplicate keys → convert FormData to a JSON-ready object
    for (const [k, v] of fd) {
      let key = k;
      if (key.endsWith('[]')) {
        // remove the [] from the key
        key = key.slice(0, -2);
      }

      if (formData[key] === undefined) {
        formData[key] = v;
      } else if (Array.isArray(formData[key])) {
        (formData[key] as unknown[]).push(v);
      } else {
        formData[key] = [formData[key], v];
      }
    }

    // Handle Rails checkbox pattern: when checkbox is checked, we get ["0", "1"]
    // We want just "1" for checked and "0" for unchecked
    for (const [key, value] of Object.entries(formData)) {
      if (
        Array.isArray(value) &&
        value.length === 2 &&
        value.includes('0') &&
        value.includes('1')
      ) {
        // This looks like a Rails checkbox pattern - use the "1" value (checked state)
        formData[key] = '1';
      } else if (
        Array.isArray(value) &&
        value.length === 1 &&
        value[0] === '0'
      ) {
        // Single "0" value means unchecked checkbox
        formData[key] = '0';
      }
    }
  }

  return formData;
}
